import SmartFeedEngine from "~/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import useFanPublicationStore from "%/stores/fan-publication-store";

export const useMyPublicationWorkflowsFeedStore = defineSmartFeedPiniaStore(
  "my-publication-workflows-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        publicationId: {
          "key": "publication_id",
          "payload": useFanPublicationStore().publicationId,
        },
      },
    }),
    getters: {
      feedUrl() {
        return `/publication/${useFanPublicationStore().publicationId}/workflows/feed`;
      },
    },
  },
);
